module.exports = __webpack_public_path__ + "img/shrewd-save-6.81300023.webp";